document.addEventListener("DOMContentLoaded", function () {
    // スクロール時の動作を関数に定義
    function handleScroll() {
        var threshold;
        // if ($("body").hasClass("index") && $(window).width() > 989) {
        //     threshold = 3400;
        // } else {
        //     threshold = 0;
        // }
        threshold = 50;

        if ($(this).scrollTop() > threshold) {
            $("#toPageTop").addClass("opacity100");
            $(".shopify-section-header-sticky").addClass("active");
        } else {
            $("#toPageTop").removeClass("opacity100");
            $(".shopify-section-header-sticky").removeClass("active");
        }
    }

    // スクロールイベントに関数をバインド
    $(window).on("scroll", handleScroll);

    // ページロード時に関数を実行
    $(document).ready(handleScroll);
    
    $("#toPageTop").on("click", function(e) {
        e.preventDefault();
        $("#MainContent").get(0).scrollIntoView({ behavior: "smooth" });
    });

});



jQuery(function($){
    var targetURL = "https://sanei-sangyo.jp/wp-json/wp/v2/news/?_embed";
   
    $.ajax({
        type: 'GET',
        url: targetURL,
        dataType: 'json',
        timeout: 30000,
        success: function(data){
            if(data.length > 0) {
                // 新着情報1件を取得
                var firstNews = data[0];
                var date = new Date(firstNews["date"]);
                var formattedDate = formatDate(date , "YYYY年MM月DD日");
                
                // フッターのHTMLに新着情報を反映
                $("#footerNews").attr("href", "https://saneibags.com/#news");
                $("#footerNewsDate").text(formattedDate);
                $("#footerNewsTitle").text(firstNews["title"]["rendered"]);
            }
        },
        error: function(){
            // エラーが発生した場合の処理
            console.log('データの取得に失敗しました。');
        }
    });
    
});

var formatDate = function (date, format) {
    if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
    format = format.replace(/YYYY/g, date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    if (format.match(/S/g)) {
      var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
      var length = format.match(/S/g).length;
      for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
    }
    return format;
};
